import { FlowDurationUnits } from 'flow-schema';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';

export function WaitV2FormFields() {
  return (
    <>
      <BlockDurationField
        fieldName="config.duration"
        unitFieldNameSuffix="units"
        required={false}
        allowedUnits={Object.values(FlowDurationUnits)}
        toggleLabel="Use pre-defined wait duration"
        valueLabel="Pre-defined wait duration"
        valueHelperText="The amount of time to wait."
      />
      <BlockValueTemplateField
        fieldName="config.waitUntilDate"
        label="Dynamic wait duration or target datetime"
        helperText="The number of milliseconds to wait, or target datetime until which to wait. This can be dynamically specified via {{...}} notation."
        required={false}
      />
    </>
  );
}
